import React from 'react';
import { Home, Car, ShoppingBag, User } from 'lucide-react';

interface BottomNavigationProps {
  currentTab: string;
  onTabChange: (tab: string) => void;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({ currentTab, onTabChange }) => {
  const tabs = [
    { id: 'home', label: '首页', icon: Home },
    { id: 'vehicle', label: '车辆', icon: Car },
    { id: 'store', label: '商店', icon: ShoppingBag },
    { id: 'my', label: '我的', icon: User },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
      <div className="flex justify-around">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex flex-col items-center py-2 px-4 flex-1 ${
              currentTab === tab.id
                ? 'text-primary'
                : 'text-gray-500'
            }`}
          >
            <span className="text-xl mb-1">
              {React.createElement(tab.icon, { size: 24, className: 'w-6 h-6' })}
            </span>
            <span className="text-xs">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BottomNavigation;
